// All runtime config comes from VITE_* env vars (set per stage at build time),
// replacing the old hardcoded BASE_URL / Pusher key / Maps key.
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? "https://dev.api.smartsafiri.tz/api/v1";
export const MAPS_API_KEY = import.meta.env.VITE_MAPS_API ?? "";
export const PUSHER_KEY = import.meta.env.VITE_PUSHER_KEY ?? "";
export const PUSHER_CLUSTER = import.meta.env.VITE_PUSHER_CLUSTER ?? "ap2";
